import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
	return (
		<div>
			<nav className="navbar navbar-expand-lg bg-light">
				<div className="container">
					<NavLink className="navbar-brand" to="/">
						LA COLLECTION
					</NavLink>
					<button
						className="navbar-toggler"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#navbarSupportedContent"
						aria-controls="navbarSupportedContent"
						aria-expanded="false"
						aria-label="Toggle navigation"
					>
						<span className="navbar-toggler-icon" />
					</button>
					<div className="collapse navbar-collapse" id="navbarSupportedContent">
						<ul className="navbar-nav mx-auto mb-2 mb-lg-0">
							<li className="nav-item">
								<NavLink className="nav-link active" aria-current="page" to="/">
									Home
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink className="nav-link" to="/products">
									Products
								</NavLink>
							</li>
						</ul>
						<div className="buttons ">
							<NavLink to="/login" className="btn btn-outline-dark">
								<i className="fa fa-sign-in me-1" /> Login
							</NavLink>
							<NavLink to="/register" className="btn btn-outline-dark ms-2">
								<i className="fa fa-user-plus me-1" /> Register
							</NavLink>
							<NavLink to="/cart" className="btn btn-outline-dark ms-2">
								<i className="fa fa-shopping-cart me-1" /> Cart (0)
							</NavLink>
						</div>
					</div>
				</div>
			</nav>
		</div>
	);
};

export default Navbar;
